import { render, staticRenderFns } from "./DataComponent.vue?vue&type=template&id=437447a6&scoped=true&"
import script from "./DataComponent.vue?vue&type=script&lang=js&"
export * from "./DataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437447a6",
  null
  
)

export default component.exports